import Dashboard from "../../Pages/Dashboard";
import { navigationMapBuilder } from "./helpers";

const navigation = [
  {
    header: "Dashboard",
    links: [
      {
        text: "Dashboard",
        icon: <></>,
        route: "",
        component: Dashboard,
      },
    ],
  },
];

const navigationMap = (parentRoute,layout) =>
  navigationMapBuilder(parentRoute, navigation,layout);


export default navigationMap;
